import React from 'react';

const StagnantCases = ({ cases, loading }) => {
    if (loading) {
        return (
            <div className="bg-gray-800 rounded-lg border border-orange-900/30 shadow-lg overflow-hidden h-48 animate-pulse">
                <div className="bg-orange-900/20 p-4 border-b border-orange-900/30 h-14"></div>
            </div>
        );
    }

    return (
        <div className="bg-gray-800 rounded-lg border border-orange-900/30 shadow-lg overflow-hidden h-full flex flex-col">
            <div className="bg-orange-900/20 p-4 border-b border-orange-900/30 flex justify-between items-center flex-shrink-0">
                <h2 className="text-orange-400 font-bold uppercase tracking-wider flex items-center gap-2 text-sm sm:text-base">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    Stagnant Cases
                </h2>
                <span className="text-xs bg-orange-900/50 text-orange-300 px-2 py-1 rounded border border-orange-800 hidden sm:inline-block">
                    &gt; 7 Days
                </span>
            </div>
            <div className="flex-1 overflow-y-auto">
                {cases.length > 0 ? (
                    <div className="divide-y divide-gray-700">
                        {cases.map((c) => (
                            <div key={c.id} className="p-4 hover:bg-gray-700/50 transition-colors flex justify-between items-center group">
                                <div>
                                    <h4 className="text-sm font-medium text-white group-hover:text-orange-300 transition-colors">{c.title}</h4>
                                    <p className="text-xs text-gray-500 mt-1">Last updated: {new Date(c.updated_at).toLocaleDateString()}</p>
                                </div>
                                <div className="text-right">
                                    <span className="text-xs text-gray-400 block">{c.assigned_to || 'Unassigned'}</span>
                                    <span className="text-xs text-orange-400 uppercase">{c.status}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="p-8 text-center text-gray-500 flex items-center justify-center h-full">
                        No stagnant cases found. Good job!
                    </div>
                )}
            </div>
        </div>
    );
};

export default StagnantCases;
